module.exports = __webpack_public_path__ + "img/success-icon.1ac84066.png";